import { getEducationHistoryDetail, getEducationAction } from "./CrGEFCRRRI01/GEFCRRRI01Reducer";

export const efReducer = {
    getEducationHistoryDetail,
    getEducationAction
};
